// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__16HZ5","row":"Option_row__ouCED"};